import React, { useRef } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import Dropdown from '../../../components/base/Dropdown/Dropdown';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { statusClassName } from '../../../utils/formatters';

export default function CameraSelector(props) {
  const {
    disabled = false,
    onSelect = () => {},
    selected = 0,
    options = [],
  } = props;
  const intl = useIntl();
  const { formatMessage } = intl;
  const anchorElement = useRef(null);
  const inputOption = options.find(i => i.value === selected);
  const selectedName = inputOption && inputOption.name ? inputOption.name : formatMessage({ id: 'file.select' });
  const selectedStatus = inputOption && typeof inputOption.status !== 'undefined' ? inputOption.status : null;
  return (
    <Dropdown
      dropBottom
      usePortal
      disabled={disabled}
      className="camera-selector"
    >
      <Dropdown.Toggle>
        <div ref={anchorElement} className={classNames('camera-toggle', { disabled })}>
          {selectedStatus !== null ? <div className={classNames('indicator', statusClassName(selectedStatus))} /> : null}
          <div className="camera-label">{selectedName}</div>
          <Icons customIcon icon="arrow-down-2" className="arrow-icon" />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="camera-options-wrapper"
        anchorElement={anchorElement}
        classNamePortal=""
      >
        <div className="select-options-list">
          {/* <div */}
          {/*  className={classNames('camera-option', { selected: selected === null })} */}
          {/*  onClick={() => onSelect(null)} */}
          {/* > */}
          {/*  <div>{formatMessage({ id: 'file.select' })}</div> */}
          {/* </div> */}
          {options.map((item, key) => (
            <div
              key={key}
              className={classNames('camera-option', { selected: item.value === selected })}
              onClick={() => {
                onSelect(item.value);
              }}
            >
              <div className={classNames('indicator', statusClassName(item.status))} />
              <div>{item.name}</div>
            </div>
          ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
